import React from 'react';
import { CheckIcon, RulerIcon } from 'lucide-react';
import { Button } from './ui/Button';
import { Countdown } from './ui/Countdown';
import { checkoutUrl, price, priceBefore, productShortName, totalBonuses, totalVolumes } from '../data/offer';
const assurances = ['7-day guarantee', 'Secure payment', 'Instant access', 'Teach surveying with confidence starting today'];
export function FinalCta() {
  return <section className="bg-stage-field plan-grid-dark py-16 sm:py-20" aria-labelledby="final-title" data-id="element-70" data-mp="1jbtx1n5p8sc8">
      <div className="mx-auto max-w-3xl px-4 text-center" data-id="element-71" data-mp="1ed8uhh2z5wkm">
        <p className="inline-flex items-center gap-2 text-xs font-extrabold uppercase tracking-[.16em] text-goldBright" data-id="element-72" data-mp="1t3g6pf2e2jcv">
          <RulerIcon className="h-4 w-4" aria-hidden="true" data-id="element-73" data-mp="1o4wit948ixhv" /> {productShortName}
        </p>
        <h2 id="final-title" className="mx-auto mt-5 max-w-2xl text-balance text-3xl font-extrabold text-cream sm:text-4xl" data-id="element-74" data-mp="222uychuakzyy">
          Created by surveying specialists, for educators worldwide
        </h2>

        <Countdown className="mt-8" data-id="element-75" data-mp="n6nsn2tp2cyw" />

        <div className="mt-8 flex flex-col gap-5 rounded-xl border border-line bg-white p-6 text-left shadow-lift sm:flex-row sm:items-center sm:justify-between" data-id="element-76" data-mp="n7p7lidtzjlw">
          <p data-id="element-77" data-mp="x2qyainr8tql">
            <b className="block text-sm uppercase leading-tight text-forestDeep" data-id="element-78" data-mp="x27dmu6pzr8v">{productShortName}</b>
            <span className="text-sm text-inkSoft" data-id="element-79" data-mp="124g4nl018j8c">
              {totalVolumes} volumes + {totalBonuses} bonuses · Instant access
            </span>
          </p>
          <div className="sm:text-right" data-id="element-80" data-mp="1b2rwfqcmxn2d">
            <p className="text-sm text-inkSoft" data-id="element-81" data-mp="1b1qm5o3g14lp">
              <span className="mr-2 line-through" data-id="element-82" data-mp="1ftqgn10qv5aw">{priceBefore}</span>
              <b className="text-base text-forest" data-id="element-83" data-mp="1fwmekpcldtzc">{price}</b>
            </p>
            <Button href={checkoutUrl} target="_blank" rel="noopener noreferrer" size="sm" className="mt-2" data-id="element-84" data-mp="1ksl4ihdkjk1v">
              Get my teacher ready now
            </Button>
          </div>
        </div>

        <ul className="mt-8 flex flex-wrap justify-center gap-x-5 gap-y-2 text-xs font-semibold text-beige" data-id="element-85" data-mp="1tuawbobd4l06">
          {assurances.map(item => <li key={item} className="inline-flex items-center gap-1.5" data-id="element-86" data-mp="3lw45jjhxhic1">
              <CheckIcon className="h-4 w-4 text-goldBright" aria-hidden="true" data-id="element-87" data-mp="3hl5z8jysgd5" /> {item}
            </li>)}
        </ul>
      </div>
    </section>;
}